import { CircularProgress } from '@mui/material'

export const LoadingPage = () => (
  <div className='loading col-span-full w-full min-h-[calc(100svh-248px)] flex justify-center items-center'>
    <CircularProgress className='text-pi-principal-blue' />
  </div>
)

export default LoadingPage
